import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faBookOpen,
  faExclamationTriangle,
  faRotateRight,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { BASE_URL } from "../../config";
import { MarkdownSpecsContent } from "../Member/BatchFileSpecsModal";

const BACKEND_MODULE_SPECS_ENDPOINT = `${BASE_URL}/backend-modules/specs`;

const BackendModuleSpecsPage = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loadSpecs = () => {
    setLoading(true);
    setError("");

    axios
      .get(BACKEND_MODULE_SPECS_ENDPOINT, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
          Accept: "text/markdown,text/plain,*/*",
        },
        responseType: "text",
        transformResponse: [(data) => data],
      })
      .then((response) => {
        setContent(typeof response.data === "string" ? response.data : "");
      })
      .catch((requestError) => {
        if (requestError.response?.status === 401) {
          window.location.href = "/login";
          return;
        }

        const responseText = requestError?.response?.data;
        setError(
          typeof responseText === "string" && responseText.trim()
            ? responseText
            : "Unable to load Backend Module specs."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadSpecs();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="mx-auto max-w-6xl">
        <div className="mb-4 rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex min-w-0 items-center gap-3">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md bg-blue-100 text-blue-700">
                <FontAwesomeIcon icon={faBookOpen} />
              </div>
              <div className="min-w-0">
                <h1 className="truncate text-xl font-bold text-gray-900">
                  Backend Module Specs
                </h1>
                <p className="text-xs text-gray-500">
                  Full action details, conditions, and database effects
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => navigate("/backend")}
              className="inline-flex items-center justify-center gap-2 rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50"
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              Backend
            </button>
          </div>
        </div>

        <div className="rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
          {loading ? (
            <div className="flex min-h-[420px] flex-col items-center justify-center gap-3 text-gray-600">
              <FontAwesomeIcon icon={faSpinner} className="text-2xl text-blue-600 animate-spin" />
              <p className="text-sm font-medium">Loading specs...</p>
            </div>
          ) : error ? (
            <div className="rounded-md border border-red-200 bg-red-50 p-4 text-red-800">
              <div className="flex items-start gap-3">
                <FontAwesomeIcon icon={faExclamationTriangle} className="mt-1 text-red-600" />
                <div className="flex-1">
                  <p className="text-sm font-semibold">Specs unavailable</p>
                  <p className="mt-1 text-sm">{error}</p>
                  <button
                    type="button"
                    onClick={loadSpecs}
                    className="mt-3 inline-flex items-center gap-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white hover:bg-red-700"
                  >
                    <FontAwesomeIcon icon={faRotateRight} />
                    Retry
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <MarkdownSpecsContent content={content} className="mx-auto max-w-5xl pb-4" />
          )}
        </div>
      </div>
    </div>
  );
};

export default BackendModuleSpecsPage;
